var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "drugSearchComponent" }, [
    _c("div", { staticClass: "flex drug_select_block" }, [
      _c(
        "div",
        { staticClass: "maxWidth" },
        [
          _c(
            "v-select",
            {
              ref: "select",
              attrs: {
                label: "title",
                filterable: false,
                options: _vm.drugList,
              },
              on: { input: _vm.selectDrug, search: _vm.searchDrug },
              nativeOn: {
                keypress: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  $event.preventDefault()
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "option",
                  fn: function (option) {
                    return [
                      _c(
                        "div",
                        { staticClass: "d-center" },
                        [
                          option && option.title
                            ? [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(option.title) +
                                    " (" +
                                    _vm._s(option.id) +
                                    ") "
                                ),
                                _c("b", [
                                  _vm._v(
                                    "[" +
                                      _vm._s(option.main_store.qty) +
                                      " уп.]"
                                  ),
                                ]),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]
                  },
                },
                {
                  key: "selected-option",
                  fn: function (option) {
                    return [
                      option && option.title
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(option.title) +
                                " (" +
                                _vm._s(option.id) +
                                ") "
                            ),
                            _c("b", [
                              _vm._v(
                                "[" + _vm._s(option.main_store.qty) + " уп.]"
                              ),
                            ]),
                          ]
                        : _vm._e(),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.drug,
                callback: function ($$v) {
                  _vm.drug = $$v
                },
                expression: "drug",
              },
            },
            [
              _c("template", { slot: "no-options" }, [
                _vm._v("\n          введите название препарата..\n        "),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.enableQty
        ? _c("div", { staticClass: "flex" }, [
            _vm.drug
              ? _c("div", { staticClass: "wd-70" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.drug.qty,
                        expression: "drug.qty",
                      },
                    ],
                    staticClass: "form-control border-r-0 h-100",
                    attrs: {
                      placeholder: "Количество",
                      type: "number",
                      name: "qty",
                    },
                    domProps: { value: _vm.drug.qty },
                    on: {
                      change: _vm.updateDrug,
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.drug, "qty", $event.target.value)
                      },
                    },
                  }),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }